// removed by extract-text-webpack-plugin
module.exports = {"footer-button":"ProfileFooter__footer-button___3O9XW"};